import { Spacing } from "../../foundations/spacing.es.js";
import { FontSize, FontWeight, LetterSpacing } from "../../foundations/typography.es.js";
const CHIP_SMALL_DELETE_ICON_SIZE = "0.833rem";
const chipStyleOverrides = {
  root: {
    padding: `${Spacing["750"]} ${Spacing["1000"]}`,
    gap: Spacing["250"],
    fontSize: FontSize["xs"],
    fontWeight: FontWeight["bold"],
    letterSpacing: LetterSpacing["widerMedium"]
  },
  icon: {
    marginLeft: Spacing["0"],
    marginRight: Spacing["0"]
  },
  deleteIcon: {
    height: Spacing["1500"],
    width: Spacing["1500"],
    marginLeft: Spacing["0"],
    marginRight: Spacing["0"],
    "&.MuiChip-deleteIconSmall": {
      width: CHIP_SMALL_DELETE_ICON_SIZE,
      height: CHIP_SMALL_DELETE_ICON_SIZE
    }
  },
  label: {
    paddingLeft: Spacing["0"],
    paddingRight: Spacing["0"]
  }
};
export {
  chipStyleOverrides
};
//# sourceMappingURL=styles.es.js.map
